import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import type { VesselFilter } from '../types/vessel';

interface FilterBarProps {
  currentFilter: VesselFilter;
  onFilterChange: (filter: VesselFilter) => void;
  counts: { total: number; lng: number; bunker: number; favorites: number };
  labelsVisible: boolean;
  onToggleLabels: () => void;
}

export function FilterBar({
  currentFilter,
  onFilterChange,
  counts,
  labelsVisible,
  onToggleLabels,
}: FilterBarProps) {
  const filters: Array<{ value: VesselFilter; label: string; countKey: keyof typeof counts }> = [
    { value: '', label: 'All', countKey: 'total' },
    { value: 'LNG', label: 'LNG', countKey: 'lng' },
    { value: 'Bunkervessel', label: 'Bunker', countKey: 'bunker' },
    { value: 'Favorites', label: 'Favs', countKey: 'favorites' },
  ];

  const segmentStyle = (active: boolean): React.CSSProperties => ({
    width: '52px',
    padding: '8px 6px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: active ? '#525390' : 'white',
    color: active ? 'white' : '#333',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'all 0.15s',
  });

  return (
    <div style={{ position: 'absolute', top: '16px', right: '16px', display: 'flex', flexDirection: 'column', gap: '6px', zIndex: 20 }}>
      {filters.map((f) => (
        <div
          key={f.value}
          style={segmentStyle(currentFilter === f.value)}
          onClick={() => onFilterChange(f.value)}
        >
          <span style={{ fontSize: '16px', fontWeight: 700, lineHeight: 1.2 }}>{counts[f.countKey]}</span>
          <span style={{ fontSize: '9px', textTransform: 'uppercase', fontWeight: 500, letterSpacing: '0.3px' }}>{f.label}</span>
        </div>
      ))}
      <div
        style={segmentStyle(labelsVisible)}
        onClick={onToggleLabels}
      >
        <FontAwesomeIcon icon={faTags} style={{ fontSize: '16px' }} />
        <span style={{ fontSize: '9px', textTransform: 'uppercase', fontWeight: 500, letterSpacing: '0.3px' }}>Labels</span>
      </div>
    </div>
  );
}
